export default [
  {
    title: "Avy-Tmpl integration",
    key: "INTEGRATION",
    visited: true,
    hasError: false,
    fieldKeys: ["should_sync_to_avytmpl"],
  },
];
